"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const context_1 = require("./context");
const react_1 = require("react");
const reducer_1 = require("./reducer");
const constants_1 = require("./constants");
exports.useFeatureDemoContext = () => {
    return react_1.useContext(context_1.FeatureDemoContext);
};
exports.useFeatureDemoReducer = (initialState) => {
    return react_1.useReducer(reducer_1.featureDemoReducer, Object.assign(Object.assign({}, constants_1.DEFAULT_FEATURE_DEMO_STATE), initialState));
};
//# sourceMappingURL=hooks.js.map